/** @deprecated Please use Tailwind classes instead */
export const useBEMClasses = (
  blockElement: string,
  modifierNames: Record<string, unknown>,
) => {
  const modifiers: Record<string, string> = {};

  Object.keys(modifierNames).forEach(modifier => {
    modifiers[`${blockElement}--${modifier}`] = modifier;
  });

  return {
    modifiers,
  };
};
